import { render, staticRenderFns } from "./investor_relations.vue?vue&type=template&id=e98c1d24&scoped=true&"
import script from "./investor_relations.vue?vue&type=script&lang=js&"
export * from "./investor_relations.vue?vue&type=script&lang=js&"
import style0 from "./investor_relations.vue?vue&type=style&index=0&id=e98c1d24&lang=scss&scoped=true&"
import style1 from "./investor_relations.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98c1d24",
  null
  
)

export default component.exports